/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { getRandomkey } from '../helper/utils';
// Create Slice combine the actions, initialState, and reducer into 1 function

export function toasterMessageSelector(state) {
  return state?.toasterMessage;
}
const toasterMessageSlice = createSlice({
  name: 'userType',
  initialState: {
    message: '',
    id: ''
  },
  reducers: {
    saveToasterMessage: (state, action) => {
      state.message = action.payload;
      state.id = getRandomkey();
    }
  }
});

// Export actions
export const { saveToasterMessage } = toasterMessageSlice.actions;

// Export reducer
export default toasterMessageSlice.reducer;
